<template>
  <div>
    <b-card no-body v-if="trackingSourcesReports">
      <b-card-body>
        <b-row>
          <b-col md="6" lg="4" v-for="(source, key) in trackingSourcesReports" :key="key">
            <b-card no-body>
              <b-card-header>
                <h3 class="mb-0">{{ key }}</h3>
              </b-card-header>
              <table class="table table-sm">
                <tr v-for="(user, key) in source" :key="key">
                  <td>
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="user.user + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + user.avatar">
                      </span>
                      <span>{{ user.user }}</span>
                    </div>
                  </td>
                  <td class="align-middle">{{ user.value }}</td>
                </tr>
              </table>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  props: {
    userRoute: null,
    start_date: null,
    end_date: null,
    range: null,
    rangeTitle: null
  },
  data() {
    return {
      trackingSourcesReports: null
    }
  },
  methods: {
    async getTrackingSourcesReport() {
      let startDate = new Date(this.start_date).toLocaleDateString("en-US");
      let endDate = new Date(this.end_date).toLocaleDateString("en-US");

      axios.get(this.userRoute + "/tracking-sources/reports?start_date=" + startDate + "&end_date=" + endDate)
      .then(response => {
        this.trackingSourcesReports = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
  },
  created() {
    this.getTrackingSourcesReport();
  },
  watch: {
    start_date(to, from) {
      this.getTrackingSourcesReport();
    },
    end_date(to, from) {
      this.getTrackingSourcesReport();
    },
  }
};
</script>